import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '影视分类', to: '/category' },
  { label: '资讯专题', to: '/news' },
  { label: '关于我们', to: '/about' },
];

const categoryLinks = [
  { label: '电视剧大全', to: '/category?type=tv' },
  { label: '电影精选', to: '/category?type=movie' },
  { label: '高分神剧', to: '/category?tag=高分神剧' },
  { label: '治愈片单', to: '/category?tag=治愈系' },
];

const hotTags = ['悬疑', '犯罪', '古装', '科幻', '都市爱情', '治愈', '青春'];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-100/70">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-primary-600 text-background-50">
                <i className="ri-plant-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                粉色水蜜桃
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              综合影视内容展示与资讯平台，为你整理电视剧、电影的剧情介绍、演员信息与最新影视动态。
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
              hello@pinkpeach-demo.com
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">影视分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">热门标签</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <Link
                  key={tag}
                  to={`/category?tag=${encodeURIComponent(tag)}`}
                  className="rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 粉色水蜜桃 · 综合影视站（演示站点，内容均为虚构）</p>
          <p>本站不提供真实播放与下载服务，演员、评分等信息均为演示数据。</p>
        </div>
      </div>
    </footer>
  );
}